/**
 * Shared pagination decision for the experiences / experiences-list infinite
 * queries. Both response bodies expose an array field plus a numeric `page`,
 * and both stop paging once a page comes back short of `limit`.
 *
 * The array is guarded because response bodies are not validated against their
 * schema before reaching react-query: a malformed/empty backend payload can
 * arrive without the array, and throwing inside `getNextPageParam` surfaces as
 * an unhandled rejection that crashes the app (WEB-UI-981 / WEB-UI-982). A
 * missing or short page means there is nothing more to page.
 */
export const getNextPageParam = (
  items: unknown[] | undefined,
  page: number | null | undefined,
  limit: number
): number | undefined => {
  if ((items?.length ?? 0) < limit) {
    return undefined;
  }
  return typeof page === "number" ? page + 1 : undefined;
};
